import { AfterViewInit, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { InputComponent } from "../../shared/input/input.component";
import { SelectedComponent } from "../../shared/selected/selected.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../services/security.service';
import { ConfigBirthDate, ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { BirthdateComponent } from "../../shared/birthdate/birthdate.component";
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import { ModalComponent } from "../../shared/modal/modal.component";
import { ListsService } from '../../services/lists.service';
import { from } from 'rxjs';
import { ErrorScreenComponent } from "../../shared/error-screen/error-screen.component"; // Importación añadida
import { LogRedebanSoyyoService } from '../../services/log-redeban-soyyo.service';
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';
import { AUTHENTICATED_USER_CODES, ENROLLMENT_BIOMETRIC_PHOTO, ENROLLMENT_DOCUMENT_VALIDATE_CODES, ENROLLMENT_REGISTER_DATA_CODES, SoyYoService } from '../../soy-yo/services/soy-yo.service';

@Component({
  selector: 'app-form-data-basic',
  imports: [
    InputComponent,
    SelectedComponent,
    ReactiveFormsModule,
    BirthdateComponent,
    CommonModule,
    ModalComponent,
    ErrorScreenComponent,
],
  templateUrl: './form-data-basic.component.html',
  styleUrl: './form-data-basic.component.css'
})
export class FormDataBasicComponent implements OnInit, AfterViewInit {

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: '¿Comó te llamas?', subLabel: '', formName: 'fullname', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.minLength(3), Validators.maxLength(35)], textError: 'Tu nombre debe tener más de 3 caracteres y no debe contener números ni caracteres especiales.'},
    { label: 'Número de Identificación', subLabel: '(Debes seleccionar primero el tipo de identificación)', formName: 'identification', placeholder: '', type: 'tel', defaultValue: '', enabled: true, validation: [Validators.required, Validators.min(100000), Validators.max(10000000000)], textError: 'Debes digitar un número de identificación válido sin espacios ni separadores de miles.' },
    { label: 'Número de Celular', subLabel: '(para enviar códigos de seguridad)', formName: 'phone', placeholder: '', type: 'tel', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.min(3000000000), Validators.max(3999999999)], textError: 'Tu numero debe tener 10 dígitos sin espacios.'},
    { label: 'Correo electrónico', subLabel: '', formName: 'email', placeholder: '', type: 'email', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.email], textError: 'Debes digitar un correo válido.'},
  ])

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
        { label: 'Tipo de Identificación', subLabel: '', formName: 'identificationType', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([{ value: 1, label: 'Cédula de Ciudadanía' }, { value: 2, label: 'Cédula de Extranjería' }])},
        { label: 'Nacionalidad', subLabel: '', formName: 'nationalityId', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona una Nacionalidad', options: signal([]) },
    ])

  birthdateConfig = signal<ConfigBirthDate>({
    label: 'Fecha de nacimiento',
    subLabel: '',
    defaultValue: null
  });

  requiredValidator = null;

  form: FormGroup;
  birthdateSelected: any;
  currentStep = 1;
  step:number | null = null;
  titleError: string = '';
  descriptionError: string = '';
  nextRoute: WritableSignal<string> = signal('');

  // Signals
  showTerms = signal(false);
  showModal = signal(false);
  recentlyOnboarding = signal(false);
  showAlert = signal(false);
  showError = signal(false);
  validatePerson = signal(false);

  disabledButton = false;

  processGuid: string = '';
  validateWithOlimpia = false;

  constructor(
    private _router: Router,
    private title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _logRedebanSoyyoService: LogRedebanSoyyoService,
    private _soyYoService: SoyYoService,
    private _listsService: ListsService,
    private _routeService: RouteService,
    private _helpService: HelpService

  ){
    this.title.setTitle('Onboarding Digital | Datos Básico');

    this.form = new FormGroup({
        fullname: new FormControl(null, Validators.required),
        identificationType: new FormControl(null, Validators.required),
        identification: new FormControl(null, Validators.required),
        phone: new FormControl(null, Validators.required),
        email: new FormControl(null, Validators.required),
        birthday: new FormControl(null, Validators.compose([
          Validators.required,
        ])),
        nationalityId: new FormControl(null, Validators.compose([
          Validators.required,
        ])),
        authorization: new FormControl(null, Validators.compose([
          Validators.requiredTrue
        ])),
      });

      this.form.get('identificationType')?.valueChanges.subscribe((value: any) => {
        if(value === '1' || value === 1) {
          this.form.get('nationalityId')?.setValue(1);
        }else{
          this._listsService.getNationalities().subscribe({
            next: (response: any) => {
              this.dataSelected().at(1)?.options.set(response);
            },
            error: (error: any) => {
              console.error('Error fetching nationalities', error);
            }
          });
        }
      });
    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
  }

  ngOnInit(): void {
    this._helpService.show();
      this.getData();
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  handleSelect(event: {formName: string, value: string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  handleBirthdate(event: {year: string, month:string, day:string}) {
    this.form.get('birthday')?.setValue(`${event.year}-${event.month}-${event.day}`)
  }

  handleValue(event: {formName:string, value:string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  //Get Functions
  getData(){
    this._securityService.getTypedPersonData().subscribe({
      next: (response: any) => {
        this.step = Number(response?.checkpoint?.split('_')[response?.checkpoint?.split('_')?.length - 1]);
        //Antes de hacer el patchValue, verificar que el response tenga los campos necesarios
        if(response?.fullname && response?.identificationType && response?.identification && response?.phone && response?.email && response?.birthday && response?.nationalityId) {
          this.dataInputs.update((inputs:any) =>
            inputs.map((input:any) => {
              const value = (response as any)[input.formName]; // busca por nombre de campo
              return {
                ...input,
                defaultValue: value !== undefined ? value : input.defaultValue
              };
            })
          );

          this.dataSelected.update((selects:any) =>
            selects.map((selected:any) => {
              const value = (response as any)[selected.formName]; // busca por nombre de campo
              return {
                ...selected,
                defaultValue: value !== undefined ? value : selected.defaultValue
              };
            })
          );

          this.birthdateConfig.set({
            label: 'Fecha de nacimiento',
            subLabel: '',
            defaultValue: response?.birthday.split('-').length === 3
              ? {
                  year: Number(response.birthday.split('-')[0]) ,
                  month: Number(response.birthday.split('-')[1]),
                  day: Number(response.birthday.split('-')[2]),
                }
              : null
          });

        }
      },
      error: (error: any) => {
        console.error('Error fetching typed person data', error);
      }
    })
  }

  async validateOnboardingToday(){
      this._loaderService.show();
      const identification = this.form.get('identification')?.value as string
      this._securityService.validateOnboardingTodayByIdentification(identification).subscribe({
        next: (response: any) => {
          if(response.findToday == true){
            this.recentlyOnboarding.set(true);
            this._loaderService.hide();
          }else{
            this.recentlyOnboarding.set(false);
            this.onSubmit();
            this._loaderService.hide();
          }
        },
        error: (error:any) => {
            console.error(error)
            this._loaderService.hide();
        }
      })
    }

  async onSubmit(){
    this._loaderService.show();

      const identification = this.form.value.identification;
      const email = this.form.value.email;
      const phone = this.form.value.phone;
      const fullname = this.form.value.fullname;
      const identificationType = this.form.value.identificationType;
      const birthday = this.form.value.birthday;
      const nationalityId = this.form.value.nationalityId;
      let documentType = 'CC';
      switch(identificationType) {
        case '1':
          documentType = 'CC';
          break;
        case '2':
          documentType = 'CE';
          break;
        case 1:
          documentType = 'CC';
          break;
        case 2:
          documentType = 'CE';
          break;
        default:
          documentType = 'CC';
          break;
      }

      this.disabledButton = true;
      try {
        this.saveData(identificationType, identification, email, phone, fullname, birthday, nationalityId);
      } catch (error:any) {

        if(error?.error?.err == 'nationality is blocked'){
          this.failMessage('A007-F: No se puede realizar su vinculación por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
          this.saveLog('Error', '00-nationality is blocked', null);
          this.ngOnInit();
          return;
        }

      }

      this.saveLog('Step', '01-Inicia operacion', null);
      const soyYoModel = this._soyYoService;
      this._loaderService.show();
      soyYoModel.errorTrhowed.subscribe({
          next: async (error: any) => {
          if(error) {
            this.failMessage('106-F: Ha fallado la validación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
            this.saveLog('Error', '106-F-Validacion usuario', error);
          }
        }});
      try {
        this.saveLog('Step', 'A01-soyYoModel.init()', null);
        await soyYoModel.init();
        this.saveLog('Step', 'A02-soyYoModel.checkingCustomerRegister', null);
        await soyYoModel.checkingCustomerRegister(documentType, identification);
        this.saveLog('Step', 'A03-this.createTransaction', null);
        await this.createTransaction(soyYoModel, documentType, identification);
        this.saveLog('Step', 'A04-soyYoModel.isCustomerRegistred()', null);
        if(!soyYoModel.isCustomerRegistred()) {
            this.saveLog('Step', 'A05-soyYoModel.registerUser', null);
            const response = await soyYoModel.registerUser(email, phone, documentType, identification);

            if(!response) {
              this.failMessage('106-D: Ha fallado la validación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
              this.saveLog('Error', '106-D-Validacion usuario', response);
              return;
            }
            this.saveLog('Step', 'A06-soyYoModel.getUserRegisterDataCode()', null);

            switch(soyYoModel.getUserRegisterDataCode()) {
              case ENROLLMENT_REGISTER_DATA_CODES.SUCCESS:
                this.saveLog('Step', 'A07-soyYoModel.captureFaceProcess', null);
                await soyYoModel.captureFaceProcess(email, phone, documentType, identification);
                switch(soyYoModel.getCaptureBiometricFaceData()) {
                  case ENROLLMENT_BIOMETRIC_PHOTO.SUCCESS:
                    this.saveLog('Step', 'A08-soyYoModel.activatedUser', null);
                    await soyYoModel.activatedUser();
                    soyYoModel.getActivatedUserData();
                    if(soyYoModel.isActivatedUser()) {
                      this.saveLog('Step', 'A09-this.getTransaction', null);
                      await this.getTransaction(soyYoModel);
                    } else {
                      this.failMessage('106-A: Ha fallado la activación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                      this.saveLog('Error', '106-A-Activacion de usuario', soyYoModel.isActivatedUser());
                    }
                    break;
                  case ENROLLMENT_BIOMETRIC_PHOTO.INSUFICIENT_VALIDATION:
                    this.saveLog('Step', 'A10-soyYoModel.enrollmentDocumentValidate', null);
                    await soyYoModel.enrollmentDocumentValidate(email, phone, documentType, identification);
                    this.saveLog('Step', 'A11-soyYoModel.getDocumentValidatedData', null);
                    if(!soyYoModel.isDocumentValidated()) {
                      switch(soyYoModel.getDocumentValidatedData()?.code) {
                        case ENROLLMENT_DOCUMENT_VALIDATE_CODES.FAIL_PROCESS_CAPTURE:
                          this.failMessage('107: Falló el proceso de captura de imagen, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                          this.saveLog('Error', '107-Captura de imagen', soyYoModel.getDocumentValidatedData()?.code);
                          break;
                        case ENROLLMENT_DOCUMENT_VALIDATE_CODES.MAX_INTENT_TRIES:
                          this.failMessage('108: Ha superado el número de intentos, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                          this.saveLog('Error', '108-Numero de intentos superado', soyYoModel.getDocumentValidatedData()?.code);
                          break;
                        default:
                          this.failMessage('109: Verifica tu conexión e intenta de nuevo. Si el problema persiste, acércate a una oficina o comunícate con tu asesor...');
                          this.saveLog('Error', '109-Fallo de conexion', soyYoModel.getDocumentValidatedData()?.code);
                          break;
                        }
                    } else {
                      await soyYoModel.activatedUser();
                      soyYoModel.getActivatedUserData();
                      this.saveLog('Step', 'A12-soyYoModel.isActivatedUser', null);
                      if(soyYoModel.isActivatedUser()) {
                        await this.getTransaction(soyYoModel);
                      } else {
                        this.failMessage('109-A: Ha fallado la activación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                        this.saveLog('Error', '109-A-Activacion de usuario', soyYoModel.isActivatedUser());
                      }
                    }
                    break;
                  case ENROLLMENT_BIOMETRIC_PHOTO.FAIL_PHOTO:
                    this.failMessage('110: Falló la captura de la foto, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                    this.saveLog('Error', '110-Captura de foto', soyYoModel.getDocumentValidatedData()?.code);
                    break;
                  case ENROLLMENT_BIOMETRIC_PHOTO.MAX_INTENT_TRIES:
                    this.failMessage('111: Superó el número de intentos, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                    this.saveLog('Error', '111-Numero de intentos superado', soyYoModel.getDocumentValidatedData()?.code);
                    break;
                  default:
                    this.failMessage('112: Verifica tu conexión e intenta de nuevo. Si el problema persiste, acércate a una oficina o comunícate con tu asesor...');
                    this.saveLog('Error', '112-Fallo de conexion', soyYoModel.getDocumentValidatedData()?.code);
                    break;
                }
                break;
              case ENROLLMENT_REGISTER_DATA_CODES.INCORRECT_DATA:
                this.failMessage('101: La información ingresada no es correcta, corrija e intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
                this.saveLog('Error', '101-Informacion incorrecta', soyYoModel.getDocumentValidatedData()?.code);
                break;
              case ENROLLMENT_REGISTER_DATA_CODES.USER_ALREADY_REGISTER:
                this.failMessage('102: La información es coincidente con una ingresada, corrija e intente de nuevo o acérquese a una oficina...');
                this.saveLog('Error', '102-Informacion existente', soyYoModel.getDocumentValidatedData()?.code);
                break;
              default:
                this.failMessage('103: VVerifica tu conexión e intenta de nuevo. Si el problema persiste, acércate a una oficina o comunícate con tu asesor...');
                this.saveLog('Error', '103-Fallo de conexion', soyYoModel.getDocumentValidatedData()?.code);
                break;
            }

        } else {
          this.saveLog('step', '03-Validacion usuario', null);
          
          await this.authenticatedUserAndGetTransactionListData(soyYoModel, documentType, identification);
        }

      } catch (error) {
        this.failMessage('106-E: Ha fallado la validación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
        this.saveLog('Error', '106-E-Validacion de usuario', error);
      }

  }

  private async createTransaction(soyYoModel: SoyYoService, documentType: string, identification: any) {
    await soyYoModel.createTransaction(documentType, identification);
    if (!soyYoModel.isTransactionCreated()) {
      this.failMessage('119: No se pudo crear la transacción, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
      this.saveLog('Error', '119-Error transaccion', soyYoModel.isTransactionCreated());
    }
    this.saveLog('Step', '02-createTransaction', soyYoModel.isTransactionCreated());
  }

  private async getTransaction(soyYoModel: SoyYoService) {
    await soyYoModel.checkTramitesAuthorizationGetInformation();

    if (!soyYoModel.isTramitesAuthorizationGetInformation()) {
      this.failMessage('120: No es posible continuar porque rechazó la autorización, intente de nuevo y acéptela. En caso de ser necesario, acérquese a una oficina o comuníquese con su asesor...');
      this.saveLog('Error', '120-Rechazo autorizacion', soyYoModel.isTramitesAuthorizationGetInformation());
    } else {
      await soyYoModel.getTramitesListInformation();
      const responseSoyYoData = soyYoModel.getListInformationData();

      try {
        // Espera a que la promesa se resuelva antes de continuar
        await this.validateData(responseSoyYoData);
        if (!soyYoModel.isListInformationGetting()) {
          this.failMessage('121: Verifica tu conexión e intenta de nuevo. Si el problema persiste, acércate a una oficina o comunícate con tu asesor...');
          this.saveLog('Error', '121-Fallo conexion', soyYoModel.isListInformationGetting());
        } else {
          if (responseSoyYoData?.data?.transactionValidation[0]?.result) {
            const result = JSON.parse(responseSoyYoData.data.transactionValidation[0].result);
            if (result.results[0]?.datos_tsti.length > 0) {
              this.failMessage('122: No es posible continuar con su vinculación por este canal. Por acérquese a una oficina o comuníquese con su asesor...');
              this.saveLog('Error', '122-Error de vinculacion', result);
            } else {
              console.warn('OKKKK 1111');
              this.saveLog('Step', '05-wow', result);
              if(!this.validatePerson){
                this._router.navigateByUrl(this.nextRoute());
              }
            }
          } else {
            this.saveLog('Step', '06-wow', null);
            this._router.navigateByUrl(this.nextRoute());
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  private validateData(responseSoyYoData: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._securityService.setValidateData(responseSoyYoData)
        .subscribe({
          next: (response) => {
            resolve();
              this._router.navigateByUrl(this.nextRoute());
          },
          error: (err) => {
            console.error(err);
            this.validatePerson.set(true);
            reject(err);
          }
        });
    });
  }

  async authenticatedUserAndGetTransactionListData(soyYoModel: SoyYoService, documentType: any, identification: any) {
    await soyYoModel.authenticateUser(documentType, identification);
      if(!soyYoModel.isUserAuthenticated()) {
        switch(soyYoModel.getAuthenticatedCode()) {
          case AUTHENTICATED_USER_CODES.USER_NOT_MATCH:

            if(soyYoModel.getAuthenticatedUserData()?.data?.description === "No se puede abrir la cámara, dé permiso o reintente la captura") {
              this.failMessage('116A: No se puede acceder a la cámara para iniciar su validación biométrica, por favor asigne los permisos e intente nuevamente...');
              this.saveLog('Error', '116-A-Acceso a camara', soyYoModel.getAuthenticatedCode());
            } else {
              this.failMessage('116: Autenticación incorrecta, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
              this.saveLog('Error', '116-Fallo de autenticacion', soyYoModel.getAuthenticatedCode());
            }
            break;
          case AUTHENTICATED_USER_CODES.MAX_INTENT_TRIES:
            this.failMessage('117: Superó el número de intentos para el día de hoy, acérquese a una oficina o comuníquese con su asesor...');
            this.saveLog('Error', '117-Numero de intentos superado', soyYoModel.getAuthenticatedCode());
            break;
          default:
            this.failMessage('118: En este momento no podemos procesar tu solicitud, intenta más tarde. Si el problema persiste, acércate a una oficina o comunícate con tu asesor...');
            this.saveLog('Error', '118-Fallo de conexion', soyYoModel.getAuthenticatedCode());
            break;
        }
      } else {
        await this.getTransaction(soyYoModel);
      }
  }

  saveLog(step: string, message: string, data: any) {
    this._logRedebanSoyyoService.setLogRedebanSoyyo(step, message, data).subscribe({
      next: (response: any) => {
      },
      error: (error: any) => {
        this.validatePerson.set(true);
      }
    });
  }

  failMessage(description:string, title:string = 'Error') {
    this.titleError = title;
    this.descriptionError = description;
    this.showError.set(true);
    this.disabledButton = true;
    this._loaderService.hide();
  }

  saveData(identificationType: string | number, identification: string, email: string, phone: string, fullname: string, birthday: string | Date, nationalityId: string | number) {
    return new Promise((resolve, reject) => {
      this._securityService.setTypedPersonData(identificationType, identification, email, phone, fullname, birthday, nationalityId)
        .subscribe({
          next: async (response: any) => {
            resolve(response);

            // CAMBIAR DESDE ACA EL FLUJO PARA RETOMAR CON LA AUTENTICACION DE SOYYO @JULIAN
            this._loaderService.show();
          },
          error: async (error: any) => {
            this.validatePerson.set(true);
          }
        });
      });

  }

  proceedToNextStep() {
    if (this.currentStep === 1 ) {
      this.currentStep = 2;
    } else if (this.currentStep === 2) {
      this.showModal.set(false);
      this.currentStep = 1;
      this.requestCameraPermission();
    }
  }

  async verifyBlockIdentification() {
    const identification = this.form.get('identification')?.value;

    try{
      await this._securityService.checkBlockIdentification(identification).subscribe({
        next: (response: any) => {
          if(response.data){
          } else {
            this._router.navigateByUrl('/error');
          }
        },error:(error: any) => {
          console.error("ERROR: ", error)
        }
      });
    } catch (error) {
    }
  }

  private requestCameraPermission(): void {
    if (!navigator.mediaDevices?.getUserMedia) {
      console.error('❌ Media API not supported in this browser');
      return;
    }

    if (!navigator.permissions?.query) {
      console.error('❌ Permissions API not supported in this browser');
      return;
    }

    from(
      navigator.permissions.query({ name: 'camera' as PermissionName })
    ).subscribe({
      next: (permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          console.log('✅ Camera permission already granted');
          this.validateOnboardingToday();
        } else if (permissionStatus.state === 'prompt') {
          this.requestExplicitPermission();
        } else {
          this.showAlert.set(true)
        }
      },
      error: () => {
        this.requestExplicitPermission();
      }
    });
  }

  private requestExplicitPermission(): void {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        stream.getTracks().forEach(track => track.stop());
        console.log('✅ Camera permission granted');
        this.onSubmit();
      })
      .catch(error => {
        const errorMessage = this.getErrorMessage(error);
        this.showAlert.set(true);
        console.log(`❌ ${errorMessage}`);
      });
  }

  private getErrorMessage(error: DOMException): string {
    switch (error.name) {
      case 'NotAllowedError':
        return 'Camera permission denied by user';
      case 'NotFoundError':
        return 'No camera device found';
      case 'NotReadableError':
        return 'Camera is not available or being used by another application';
      case 'OverconstrainedError':
        return 'Cannot satisfy the requested constraints';
      case 'SecurityError':
        return 'Camera permission is disabled for security reasons';
      case 'AbortError':
        return 'Permission request was aborted';
      default:
        return `Error requesting permission: ${error.message}`;
    }
  }
}
